var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.88846 1.38672H7.91325C2.97521 1.38672 1 3.36193 1 8.29997V14.2256C1 19.1636 2.97521 21.1389 7.91325 21.1389H13.8389C18.7769 21.1389 20.7521 19.1636 20.7521 14.2256V12.2504",
    stroke: "#6842D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.866 2.39415L7.08361 10.1765C6.78733 10.4728 6.49105 11.0555 6.43179 11.4801L6.00712 14.4528C5.8491 15.5293 6.60956 16.2799 7.68605 16.1318L10.6587 15.7071C11.0735 15.6478 11.6562 15.3515 11.9624 15.0553L19.7447 7.27292C21.0879 5.92978 21.7199 4.36936 19.7447 2.39415C17.7695 0.418933 16.2091 1.051 14.866 2.39415Z",
    stroke: "#6842D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.75 3.51025C14.0775 4.67313 14.6981 5.73243 15.5523 6.58669C16.4066 7.44095 17.4659 8.06155 18.6288 8.38903",
    stroke: "#6842D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.befc6f61a828bf20514a9ab36f8af7f7.svg";
export { ForwardRef as ReactComponent };